<template>
  <warehousing-in-stack lob="AE" />
</template>

<script>
import WarehousingInStack from '@/components/Cargo/FrontEndWarehouse/warehousingInStack'
export default {
  name: 'FrontEndWarehousing',
  components: { WarehousingInStack }
}
</script>

<style scoped>

</style>
